import RegistrationBtnGroup from "../layout/RegistrationBtnGroup";
import EmailForm from "../../components/EmailForm";
import SubTitle from "../../components/SubTitle";

const contentComponentMap = {
  registrationBtnGroup: RegistrationBtnGroup,
  emailForm: EmailForm,
};

const Registration = ({ title, titleJP, content = [] }) => {
  return (
    <section className="registration-section">
      <div className="container main-section">
        <SubTitle title={title} subTitle={titleJP} />
        {content.map((block, i) => {
        const Component = contentComponentMap[block._type];
        if (!Component) {
          console.warn(`Unknown registration content type: ${block._type}`);
          return null;
        }

        switch (block._type) {
          case 'registrationBtnGroup':
            return (
              <Component
                key={block._key || i}
                buttons={block.buttons}
              />
            );
          case 'emailForm':
            return (
              <Component
                key={block._key || i}
                noPaddingTop={block.noPaddingTop}
                noPaddingBottom
                noMobilePaddingX
              />
            );
          default:
            return null;
        }
        })}
      </div>
    </section>
  );
};

export default Registration;
